var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buttons-filter-group" },
    _vm._l(_vm.entries, function (entry) {
      return !entry.hidden
        ? _c(
            "div",
            {
              key: entry.id,
              staticClass: "button-filter",
              class: { active: entry.chosen },
              on: {
                click: function ($event) {
                  return _vm.handleClick(entry)
                },
              },
            },
            [
              _c("div", { staticClass: "button-filter-name" }, [
                _vm._v(_vm._s(entry.name)),
              ]),
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }